interface Props {
  checked: boolean;
  onChange: (v: boolean) => void;
  ariaLabel?: string;
  size?: 'sm' | 'md';
  disabled?: boolean;
}

const SIZE = {
  sm: { track: 'h-5 w-9', thumb: 'h-4 w-4', on: 'translate-x-[18px]', off: 'translate-x-0.5' },
  md: { track: 'h-6 w-10', thumb: 'h-5 w-5', on: 'translate-x-[18px]', off: 'translate-x-0.5' },
};

export function Toggle({ checked, onChange, ariaLabel, size = 'md', disabled }: Props) {
  const s = SIZE[size];
  return (
    <button
      type="button"
      role="switch"
      disabled={disabled}
      aria-checked={checked}
      aria-label={ariaLabel}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex shrink-0 items-center rounded-full transition disabled:opacity-50 ${s.track} ${
        checked ? 'bg-accent-600' : 'bg-ink-300 dark:bg-ink-600'
      }`}
    >
      <span
        className={`inline-block rounded-full bg-white shadow-sm transition ${s.thumb} ${
          checked ? s.on : s.off
        }`}
      />
    </button>
  );
}
